import { render, staticRenderFns } from "./BuscarEmpresas.vue?vue&type=template&id=451b7b43&scoped=true&"
import script from "./BuscarEmpresas.vue?vue&type=script&lang=js&"
export * from "./BuscarEmpresas.vue?vue&type=script&lang=js&"
import style0 from "./BuscarEmpresas.vue?vue&type=style&index=0&id=451b7b43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451b7b43",
  null
  
)

export default component.exports